<template>
  <div class="MarkResponseList">
    <div class="table">
      <XTable
          ref="xTable"
          :api="getLessonMarkResponseList"
          :state="markResponseList"
          :columns="columns"
          :loading="markResponseListLoading"
          :tableSize="tableSize"
          :layout="layout"
      ></XTable>
    </div>
    
    <AddLessonContentModalV1
        :addType="addType"
    ></AddLessonContentModalV1>
    <AddLessonContentModalV2
        :addType="addType"
    ></AddLessonContentModalV2>
  </div>
</template>

<script>
import XTable from "@/components/XTable/index.vue";
import {mapActions, mapMutations, mapState} from "vuex";
import DateUtil from "@/utils/formatDate";
import AddLessonContentModalV1 from "@/pages/MyOutLine/AddLessonContentModalV1.vue";
import AddLessonContentModalV2 from "@/pages/MyOutLine/AddLessonContentModalV2.vue";

export default {
  name: "MarkResponseList",
  components: { XTable, AddLessonContentModalV1, AddLessonContentModalV2},
  data() {
    return {
      addType: "view",
      tableSize: "small",
      layout: "sizes, prev, pager, next",
      row: {},
      isAnswer: false,
    };
  },
  computed: {
    ...mapState("courseCenter", [
      "markResponseListLoading",
      "markResponseList",
      "addLessonContentModalV1Visible",
      "addLessonContentModalV2Visible",
    ]),
    ...mapState("user", ["permissionCode"]),
    columns: function () {
      const self = this;
      const columns = [
        // {
        //   label: "序号",
        //   render(h, scope) {
        //     return (
        //         <div>
        //           <div class="textBox">
        //             {(scope.row.name)}
        //           </div>
        //         </div>
        //     );
        //   },
        // },
        {
          prop: "classSubjectName",
          label: "系列名称",
        },
        {
          prop: "lessonName",
          label: "课程标题",
        },
        // {
        //   label: "问题内容",
        //   render(h, scope) {
        //     return (
        //         <div>
        //           <div class="textBox">
        //             {(scope.row && scope.row.question) || "-"}
        //           </div>
        //         </div>
        //     );
        //   },
        // },
        // {
        //   prop: "userName",
        //   label: "用户名",
        // },
        {
          prop: "count",
          label: "数量",
        },
        // {
        //   prop: "questionTime",
        //   label: "提问日期",
        // },
        // {
        //   label: "提问日期",
        //   render(h, scope) {
        //     return (
        //         <div>
        //           <span>{self.formatDate(scope.row.questionTime)}</span>
        //         </div>
        //     );
        //   },
        // },
      ];

      if (this.permissionCode.has('lesson:question:manager')) {
        columns.push({
          label: "操作",
          fixed: "right",
          width: 100,
          render(h, scope) {
            return (
                <div>
                  <el-button
                      onClick={() => {
                        self.handleView(scope.row);
                      }}
                      size="mini"
                      type="primary"
                      plain
                  >
                    查看
                  </el-button>
                </div>
            );
          },
        })
      }
      return columns;
    }
  },
  beforeDestroy() {
  },
  methods: {
    ...mapActions("courseCenter", [
      "getLessonMarkResponseList",
      "recommendLessonQuestion",
    ]),
    ...mapMutations("courseCenter", ["setData"]),
    async handleView(row) {
      this.row = row;
      let content = row.lessonContent // JSON.parse(row.content);
      let item = {
        type: content.contentType,
        content: content
      };

      await localStorage.setItem("lessonContentRow", JSON.stringify(item));
      if (content.version == 2) {
        await this.setData({
          key: "addLessonContentModalV2Visible",
          value: true,
        });
      } else {
        await this.setData({
          key: "addLessonContentModalV1Visible",
          value: true,
        });
      }
    },
    //   根据时间戳计算上传时间
    formatDate(timestamp) {
      return DateUtil.formatDateFromTimestamp(timestamp);
    },
  },
};
</script>

<style lang="scss" scoped>
.MarkResponseList {
  .table {
    ::v-deep .textBox {
      width: 100%;
      white-space: nowrap; /* 防止文本换行 */
      overflow: hidden; /* 超出部分隐藏 */
      text-overflow: ellipsis; /* 超出部分显示省略号 */
    }
  }
}
</style>
